import axios from "axios";
import router from "../router";
import {refreshToken} from "@/api/login";

const httpClient = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL,
  // baseURL : 'http://192.168.1.52:6100',
  timeout: 50000,
  headers: {
    "Access-Control-Allow-Origin": "*",
    "Content-Type": "application/json",
    // "Authorization": "Bearer " + localStorage.getItem('token')
  }
})
httpClient.interceptors.response.use((response) => {
    return response
}, (error) => {
  return new Promise((resolve, reject) => {

    if (error.response.status !== 401) {
      reject(error);
    }
    else {

      if(localStorage.getItem('refreshToken') ) {
        let accessTokenVal = localStorage.getItem('lotusToken');
        let refreshTokenVal = localStorage.getItem('refreshToken');
        let lastRequest = error.config;
        refreshToken(accessTokenVal,refreshTokenVal).then( (res)=>{
          localStorage.setItem('lotusToken',res.data.accessToken);
          localStorage.setItem('refreshToken',res.data.refreshToken);
          httpClient.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('lotusToken');
          lastRequest.headers['Authorization'] = 'Bearer ' + localStorage.getItem('lotusToken');
          resolve(httpClient(lastRequest))

        }).catch((e)=>{
          router.push('/login').catch(()=>{})
        })

      }
      else{
        localStorage.setItem('lotusToken',null)
        router.push('/login').catch(()=>{})
        reject(error);
      }

    }
  });
});

export default httpClient;
